import {NgModule} from '@angular/core'

import {ScrollListDirective} from './scroll-list.directive'

@NgModule({
  declarations: [ScrollListDirective],
  exports: [ScrollListDirective],
})
export class ScrollListModule {}
